<template>
  <div class="mt-12">
    <v-card max-width="90%" class="mx-auto">
      <v-card-title class="tableheader" style="padding: 20px;" >Checkout TopUp</v-card-title>
      <v-card-title class="justify-center mb-12" style="color: indigo;">Summary</v-card-title>
      <v-data-table hide-default-footer :headers="headers" :items="detailed"></v-data-table>
      <div class="mr-8 text-center">
        <v-card-text>Subscription Amount : ₹ {{Subscription_Amount}}</v-card-text>
        <v-card-text>Total NCF: ₹ {{Total_Ncf}}</v-card-text>
        <v-card-text>Tax (18% GST): ₹ {{Tax}}</v-card-text>
        <strong>
          <v-card-text>Total Amount: ₹{{total_amount}}</v-card-text>
        </strong>
      </div>
      <v-card-text>Note: Network Carrying Fee (NCF) is charged basis the total channel count. NCF for the first 100 channels is Rs. 130/- per month exclusive of taxes and for every subsequent 25 channels it is Rs.20/- per month exclusive of taxes. 1 HD channel is treated as 2 SD channels in the channel count. Terms and conditions of the Subscription Contract Apply. The discounts to NCF applied are promotional in nature and are subject to change and/or discontinuation.</v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" outlined rounded class="login mb-12" > Proceed To Pay</v-btn>
      </v-card-actions>
      </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Subscription_Amount: 200,
      Total_Ncf: 0.0,
      Tax: 12,
      total_amount: 212,
      headers: [
        {
          text: "Pack Name",
          align: "left",
          sortable: true,
          value: "Pack_Name"
        },
        {
          text: "Total Channels ",
          value: "Total_Channels"
        },
        {
          text: "Rental/month",
          
          align: "center",
          value: "Rental"
        }
      ],
      detailed: [
        {
          Pack_Name: "Hindi Starter Pack",
          Total_Channels: 6.0,
          Rental: 24
        }
      ]
    };
  }
};
</script>